import flatpickr from 'flatpickr';
import 'flatpickr/dist/themes/material_blue.css';
import * as React from 'react';
import Flatpickr from 'react-flatpickr';
import { ViewModeType } from '../../../store/types';
import { viewModeDateRangeLimits } from './CustomControls';

export interface DateRangePickerProps {
  startDate: Date;
  endDate: Date;
  viewModeType: ViewModeType;
  setRange: (startDate: Date, endDate: Date) => void;
}

export interface DateRangePickerState {
  value: Date[];
  dateRangeRef: Date | boolean;
}

export class DateRangePicker extends React.Component<DateRangePickerProps, DateRangePickerState> {
  constructor(props: DateRangePickerProps) {
    super(props);

    this.state = {
      dateRangeRef: false,
      value: [this.props.startDate, this.props.endDate]
    };

    this.setRangeReferenceDate = this.setRangeReferenceDate.bind(this);
    this.setRangeValue = this.setRangeValue.bind(this);
  }

  private setRangeValue(startDate: Date, endDate?: Date) {
    const state = this.state;
    const value = [startDate];
    
    if (endDate instanceof Date) {
      value.push(endDate);
    }

    this.setState({
      ...state,
      value
    });
  }

  private setRangeReferenceDate(dateRangeRef: Date | boolean) {
    const state = this.state;
    this.setState({
      ...state,
      dateRangeRef
    });
  }

  public render() {
    const value = [...this.state.value];
    const { dateRangeRef } = this.state;

    const {
      startDate: propsStartDate,
      endDate: propsEndDate,
      viewModeType,
      setRange
    } = this.props;

    flatpickr.l10ns.default.rangeSeparator = ' - ';
    const flatpickrConfig: flatpickr.Options.Options = {
      mode: 'range',
      dateFormat: 'd/m/Y',
      enable: [],
      disable: [],
      defaultDate: [propsStartDate, propsEndDate]
    };

    if (value[1]) {
      value[0] = propsStartDate;
      value[1] = propsEndDate;
    }

    if (dateRangeRef) {
      const { minStartDate, maxEndDate } = viewModeDateRangeLimits[viewModeType](propsStartDate, propsEndDate, dateRangeRef);

      flatpickrConfig.enable = [
        {
          from: minStartDate,
          to: maxEndDate
        }
      ];
    }

    return (
      <div className="daterange-item">
        <Flatpickr
          value={value}
          options={flatpickrConfig}
          onChange={newRange => {
            // newRange[0] is the start of the range, newRange[1] is the end of the range
            if (newRange.length < 2) {
              this.setRangeReferenceDate(newRange[0]);
              this.setRangeValue(newRange[0]);
            } else {
              this.setRangeReferenceDate(false);
              setRange(newRange[0], newRange[1]);
              this.setRangeValue(newRange[0], newRange[1]);
            }
          }}
          onClose={(selectedDates) => {
            if (selectedDates.length < 2) {
              this.setRangeValue(propsStartDate, propsEndDate);
            }
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/navbar/customControls/DateRangePicker.tsx